module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-ba6041c7ae6226a5800fa9582a646924.png";